// extracted by mini-css-extract-plugin
export var button = "_6f-4";
export var hasDarkBackground = "_6f-7";
export var hasLightBackground = "_6f-6";
export var iconWrapper = "_6f-0";
export var large = "_6f-2";
export var medium = "_6f-1";
export var small = "_6f-5";
export var xsmall = "_6f-3";